const storytellingGuideRoute = [
    {
        path: "/guide",
        name: "GuideIndex",
        component: () =>
            import(
                /* webpackChunkName: "storytellingGuide" */ "./StorytellingGuide.vue"
            ),
    },
    {
        path: "/storytelling-guide",
        redirect: "/guide",
    },
];

export default storytellingGuideRoute;
